module.exports = __webpack_public_path__ + "img/hq.55ffe26a.png";